import { createSlice } from "@reduxjs/toolkit";
import { ADD_NOTIFICATION_ACTION, ADD_UPDATE_NOTIFICATION_UNREAD_ACTION, GET_NOTIFICATION_ACTION, GET_NOTIFICATION_LANGUAGE_REQUEST_ACTION, GET_NOTIFICATION_UNREAD_COUNT_ACTION } from "./NotificationSlice.action";
const NotificationSlice = createSlice({
    name: "notification",
    initialState: {
        loading: false,
        error: null,
        notificationList: [],
        newNotificationList: [],
        newNotification_unread_count:null
    },
    extraReducers: (builder) => {
        builder
            .addCase(ADD_NOTIFICATION_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ADD_NOTIFICATION_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(ADD_NOTIFICATION_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(GET_NOTIFICATION_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_NOTIFICATION_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.notificationList = action.payload;
            })
            .addCase(GET_NOTIFICATION_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(GET_NOTIFICATION_LANGUAGE_REQUEST_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_NOTIFICATION_LANGUAGE_REQUEST_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.newNotificationList = action.payload;
            })
            .addCase(GET_NOTIFICATION_LANGUAGE_REQUEST_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(ADD_UPDATE_NOTIFICATION_UNREAD_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ADD_UPDATE_NOTIFICATION_UNREAD_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(ADD_UPDATE_NOTIFICATION_UNREAD_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(GET_NOTIFICATION_UNREAD_COUNT_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_NOTIFICATION_UNREAD_COUNT_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.newNotification_unread_count = action.payload?.r
            })
            .addCase(GET_NOTIFICATION_UNREAD_COUNT_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            
            
    }
})
export default NotificationSlice;